import { useMutation } from '@tanstack/react-query';
import { Call } from 'src/models';
import { aivaApi } from 'src/services';

export type CreateDemoCallPayload = {
  to_number: string;
  user_name: string;
  user_email: string;
  specialty_name: string;
  specialty_id: number;
  scenario: string;
  request_followup?: boolean;
};

export type CreateDemoCallResponse = { call: Call };

export const useCreateDemoCall = () => {
  return useMutation({
    mutationFn: async (payload: CreateDemoCallPayload) => {
      return aivaApi
        .post<CreateDemoCallResponse>('/call/demo', payload)
        .then((res) => res.data.call);
    },
  });
};
